import React from 'react';
import styles from './Skeleton.module.css';

interface SkeletonProps {
  type?: 'text' | 'card' | 'avatar' | 'button' | 'chart-bar';
  width?: string;
  height?: string;
  count?: number;
}

const Skeleton: React.FC<SkeletonProps> = ({ type = 'text', width, height, count = 1 }) => {
  const style = {
    width: width || undefined,
    height: height || undefined
  };

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.skeletonLine} style={style} />
      ))}
    </>
  );
};

export const BalanceCardSkeleton: React.FC = () => (
  <div className={styles.balanceCardSkeleton}>
    <div className={styles.skeletonUserInfo}>
      <div className={styles.skeletonAvatar} />
      <div className={styles.skeletonText}>
        <div className={`${styles.skeletonLine} ${styles.short}`} />
        <div className={`${styles.skeletonLine} ${styles.short}`} />
      </div>
    </div>
  </div>
);

export const ExpenseCardSkeleton: React.FC = () => (
  <div className={styles.expenseCardSkeleton}>
    <div className={styles.skeletonUserInfo}>
      <div className={styles.skeletonAvatar} />
      <div className={styles.skeletonText}>
        <div className={`${styles.skeletonLine} ${styles.long}`} />
        <div className={`${styles.skeletonLine} ${styles.short}`} />
      </div>
      <div className={`${styles.skeletonLine} ${styles.short}`} />
    </div>
  </div>
);

export const CategoryChartSkeleton: React.FC = () => (
  <div className={styles.skeletonChart}>
    {[100, 80, 60, 40, 30].map((height, index) => (
      <div 
        key={index} 
        className={styles.skeletonChartBar}
        style={{ height: `${height}%` }}
      />
    ))}
  </div>
);

export const SkeletonCard: React.FC = () => (
  <div className={styles.skeletonCard}>
    <div className={`${styles.skeletonLine} ${styles.long}`} />
    <div className={`${styles.skeletonLine} ${styles.short}`} />
  </div>
);

export const SkeletonChartBar: React.FC = () => (
  <div style={{ marginBottom: '12px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div className={`${styles.skeletonLine} ${styles.short}`} />
      <div className={styles.skeletonLine} style={{ width: '60%' }} />
      <div className={`${styles.skeletonLine} ${styles.short}`} />
    </div>
  </div>
);

export default Skeleton;

